import { PageTop } from '@/lib/core/components/Layout'
import { Section } from '@/lib/core/components/Layout/Layout.styles'

import { Dashboard } from '@/lib/features/Dashboard'
import messages from '@/lib/features/Dashboard/Dashboard.messages'

const Page = () => {
  return (
    <>
      <PageTop title={messages.pageTitle.defaultMessage} />

      <Section>
        <Dashboard />
      </Section>
    </>
  )
}

export default Page
